export enum RotateModel {
  Source = 'source',
  Target = 'target',
  None = 'none',
}

export enum SidebarTab {
  Remarks = 1,
  Participants = 2,
}
